import { Button, Modal } from 'antd';
import React, { memo } from 'react';
import './index.scss';
import { Typography } from 'antd';
import { DownloadOutlined, MobileOutlined } from '@ant-design/icons';
const { Title, Paragraph } = Typography;
type Props = {
    title: string;
    subTitle: string;
    buttonRedirectApp: string;
    buttonOpenAppStore: string;
    isOpen: boolean;
    onRedirectApp: any;
    onOpenAppStore: any;
    onCancel: any;
};
const ModalRedirectMobile = memo(
    ({
         title,
         subTitle,
         buttonRedirectApp,
         buttonOpenAppStore,
         isOpen,
         onRedirectApp,
         onOpenAppStore,
         onCancel,
     }: Props) => {
        const renderContent = () => {
            return (
                <div style={{ textAlign: 'center' }}>
                    <Title level={5} style={{ marginBottom: '15px', color: '#4877ef' }}>{title}</Title>
                    <Paragraph style={{ padding: '0 32px', marginBottom: '23px' }}>{subTitle}</Paragraph>
                    <div>

                        <Button
                            className="btn-deteke-modal-delete"
                            type="primary"
                            icon={<MobileOutlined style={{ position: 'relative', bottom: '3px' }} />}
                            onClick={onRedirectApp}
                            style={{ marginRight: '30px' }}
                        >
                            {buttonRedirectApp}
                        </Button>
                        <Button
                            className="btn-deteke-modal-delete"
                            type="primary"
                            onClick={onOpenAppStore}
                            icon={<DownloadOutlined style={{ position: 'relative', bottom: '3px' }} />}
                            title={buttonOpenAppStore}
                        >
                            {buttonOpenAppStore}
                        </Button>
                    </div>

                </div>
            );
        };

        return (
            <Modal
                width={400}
                className="modal-delete"
                title=""
                open={isOpen}
                footer={null}
                onCancel={onCancel}
            >
                {renderContent()}
            </Modal>
        );
    },
);

export default ModalRedirectMobile;